module.exports = __webpack_public_path__ + "img/fyt_p8.1ae8b860.png";